<template>
  <div>
    <div v-if="dataloaded == false" class="blackbox-loader"></div>

    <div v-show="dataloaded == true" >

    <v-container grid-list-md class="pa-0 mb-4" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            :items="companyTypes"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            v-on:input="getPopupData()"
            v-model="activeCompType"
            no-data-text="Geen type aansluiting gevonden."
            label="Selecteer type aansluiting"
            outlined
            hide-details
            dense>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>
       
      <v-card outlined> 
        <v-card-title>
          <h2>Hoofdonderwerpen</h2>
          <v-spacer></v-spacer>
          <div class="header-edit-button">
            <v-btn small class="mx-2" fab dark :color="companyPrimaryColor" @click="createnewCallTypeData('main')">
              <v-icon small dark>add</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="mainCallTypes"
          item-key="name"
          sort-by="order"
          :itemsPerPage.sync="companyPages"
          hide-default-footer
          :no-results-text="`Geen resultaten gevonden voor: ${search}`"
          no-data-text="Nog geen types toegevoegd"
          class="main-table"
          >
          <template v-slot:item="{item}">
            <tr>
              <td class="grap">
                <v-icon :color="$vuetify.theme.themes[theme].text">drag_indicator</v-icon>
              </td>
              <td>{{ item.name }}</td>
              <td>
                <v-icon small :color="activeColor(item.active)">radio_button_unchecked</v-icon>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="editCallTypeItem(item)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="removeCallTypeDialog(item)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text">delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <v-card class="mt-4" outlined> 
        <v-card-title>
          <h2>Overige onderwerpen</h2>
          <v-spacer></v-spacer>
          <div class="header-edit-button">
            <v-btn small class="mx-2" fab dark :color="companyPrimaryColor" @click="createnewCallTypeData('other')">
              <v-icon small dark>add</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="otherCallTypes"
          item-key="name"
          :itemsPerPage.sync="companyPages"
          hide-default-footer
          :no-results-text="`Geen resultaten gevonden voor: ${search}`"
          no-data-text="Nog geen types toegevoegd"
          class="other-table"
          >
          <template v-slot:item="{item}">
            <tr>
              <td class="grap">
                <v-icon :color="$vuetify.theme.themes[theme].text">drag_indicator</v-icon>
              </td>
              <td>{{ item.name }}</td>
              <td>
                <v-icon small :color="activeColor(item.active)">radio_button_unchecked</v-icon>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="editCallTypeItem(item)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="removeCallTypeDialog(item)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text">delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-dialog v-model="newCallTypeData.dialog" scrollable max-width="600px">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 style="color:white">Type gesprek toevoegen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeNewCallType()">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert class="ma-1 pa-2" v-if="newCallTypeData.feedback" :value="true" type="warning">{{ newCallTypeData.feedback }}</v-alert>

        <v-divider></v-divider>

        <v-card-text>
          <v-form  ref="editCompForm" lazy-validation>
            <v-text-field
              class="pt-4"
              label="Naam"
              v-model="newCallTypeData.name"
              :color="companyPrimaryColor"
              background-color="background"       
              hide-details
              required
              outlined
            ></v-text-field>

            <v-text-field
              class="pt-4"
              label="Id"
              v-model="newCallTypeData.id"
              :color="companyPrimaryColor"
              background-color="background"       
              :rules="[rules.senderID]"
              required
              outlined
              persistent-hint
              hint="Gebruik geen spaties, nummers of speciale tekens"
            ></v-text-field>

            <v-switch
              :color="companyPrimaryColor"
              label="Actief"
              v-model="newCallTypeData.active"
            ></v-switch>    
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  :color="companySecondaryColor"
                  @click="closeNewCallType()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companyPrimaryColor"
                  @click="addNewCallType()"
                  >
                  Gesprekstype toevoegen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editCallType.dialog" scrollable max-width="600px">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 style="color:white">Type gesprek wijzigen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeEditCallType()">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert class="ma-1 pa-2" v-if="editCallType.feedback" :value="true" type="warning">{{ editCallType.feedback }}</v-alert>

        <v-divider></v-divider>

        <v-card-text>
          <v-form  ref="editCompForm" lazy-validation>
            <v-text-field
              class="pt-4"
              label="Naam"
              v-model="editCallTypeData.name"
              :color="companyPrimaryColor"
              background-color="background"       
              hide-details
              required
              outlined
            ></v-text-field>

            <v-text-field
              class="pt-4"
              label="Id"
              v-model="editCallTypeData.id"
              readonly
              disabled
              :color="companyPrimaryColor"
              background-color="background"       
              :rules="[rules.senderID]"
              required
              outlined
              hide-details
            ></v-text-field>

            <v-switch
              :color="companyPrimaryColor"
              label="Actief"
              v-model="editCallTypeData.active"
            ></v-switch>    
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  :color="companySecondaryColor"
                  @click="closeEditCallType()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  :dark="editCallTypeChanged"
                  :depressed="!editCallTypeChanged"
                  :disabled="!editCallTypeChanged"
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companyPrimaryColor"
                  @click="updateEditCallType()"
                  >
                  Wijzigingen opslaan
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- / Delete Dialog \-->
    <v-dialog v-model="showRemoveCallTypeDialog" max-width="450">
      <v-card>
        <v-card-title class="pillar-card-title" >
          <h2>Gesprekstype verwijderen</h2>
          <div class="pillar-card-title-close" @click="removeConversionsDialog = false"></div>
        </v-card-title>
        <v-card-text>
          <div class="pt-4">
           Weet u zeker dat u dit gesprekstype definitief wilt verwijderen?
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="hogans-modal-footer clear">
            <v-btn class="modal-button-cancel" outlined depressed color="#8B93A6" @click="showRemoveCallTypeDialog = false">Annuleren</v-btn>
            <v-btn class="modal-button-next" dark rounded :color="companySecondaryColor" @click="removeCallType()">Verwijderen<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ Delete Dialog / -->

  </div>
</template>


<script>
// import { bus } from "../main";
import db from "../firebase/init";
import _ from "lodash";
import Sortable from "sortablejs";
// import draggable from "vuedraggable";

export default {

  props:{
    softwareTypes: Object,
    companyTypes: Array,
    packages: Array
  },
  name: "popup",
  data: () => ({
    search: "",
    activeCompType: null,
    companyPages: -1,
    dataloaded: false,
    editCallType: {
      dialog: false,
      type: null,
      name: null,
      id: null,
      active: true
    },
    removeItem: null,
    showRemoveCallTypeDialog: false,
    editCallTypeData: {},
    editCallTypeDataOriginal: {},
    newCallTypeData: {
      dialog: false,
      type: null,
      name: null,
      id: null,
      active: true
    },
    mainCallTypes: [],
    otherCallTypes: [],
    removeBookings: "",
    selected: [],
    branches: [],
    companies: [],
    rules: {
      senderID: value => {
        const pattern = /^[A-Za-z0-9]+$/
        return pattern.test(value) || 'Id niet geldig.'
      },
    },
    headers: [
      {
        text: "",
        align: "right",
        value: "",
        sortable: false,
        width: "30px"
      },
      {
        text: "Naam",
        align: "left",
        value: "name"
      },
      {
        text: "Actief",
        align: "center",
        value: "active",
        width: "50px"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      }
    ]
  }),

  created() {
    this.activeCompType = this.companyTypes[0].id;
    this.getPopupData();
  },

  methods: {

    activeColor(type){
      if(type){
        return 'green'
      }
      else{
        return 'red';
      }
    },

    createnewCallTypeData(type){
      this.newCallTypeData.type = type;
      this.newCallTypeData.dialog = true;
    },

    closeNewCallType(){
      this.newCallTypeData.type = null;
      this.newCallTypeData.dialog = false;
      this.newCallTypeData.name = null;
      this.newCallTypeData.id = null;
      this.newCallTypeData.active = true;
      this.newCallTypeData.feedback = null;
    },

    closeEditCallType(){
      this.editCallType.type = null;
      this.editCallType.dialog = false;
      this.editCallType.name = null;
      this.editCallType.id = null;
      this.editCallType.docId = null;
      this.editCallType.active = true;
      this.editCallType.feedback = null;
      this.editCallTypeData = {};
      this.editCallTypeDataOriginal = {};
    },

    editCallTypeItem(item){
      this.editCallTypeData = item;
      this.editCallTypeDataOriginal = _.cloneDeep(this.editCallTypeData);
      this.editCallType.dialog = true;
    },

    removeCallTypeDialog(item){
      this.removeItem = item;
      this.showRemoveCallTypeDialog = true;
    },

    removeCallType(){
      db.collection("callTypes")
        .doc(this.removeItem.docId)
        .update({
          deleted: true,
        })
        .then(()=>{
          let index = null;
          if(this.removeItem.type == 'main'){
            index = _.findIndex(this.mainCallTypes, ['docId', this.removeItem.docId]);
            this.mainCallTypes.splice(index, 1);
            this.updateOrderMainCallType();
          }
          else{
            index = _.findIndex(this.otherCallTypes, ['docId', this.removeItem.docId]);
            this.otherCallTypes.splice(index, 1);
            this.updateOrderOtherCallType();
          }
          console.log("Index: ", index)
          this.removeItem = null;
          this.showRemoveCallTypeDialog = false;
        })
    },

    updateEditCallType(){
      if(this.editCallTypeData.name){
        db.collection("callTypes")
          .doc(this.editCallTypeData.docId)
          .update({
            name: this.editCallTypeData.name,
            active: this.editCallTypeData.active
          })
          .then(()=>{
            this.closeEditCallType();
            this.getPopupData();
          })
      }
      else{
        this.editCallTypeData.feedback = "Vul alle velden in om op te slaan";
      }
    },

    addNewCallType(){
      if(this.newCallTypeData.name && this.newCallTypeData.id){
        let order = this.newCallTypeData.type == 'main' ? Number(this.mainCallTypes.length) : Number(this.otherCallTypes.length);
        let data = {
          name: this.newCallTypeData.name,
          id: this.newCallTypeData.id,
          companyType: this.activeCompType,
          type: this.newCallTypeData.type,
          order: order,
          active: this.newCallTypeData.active,
          deleted: false
        }
        db.collection("callTypes").add(data)
        .then((docRef)=>{
          data.docId = docRef.id;
          if(this.newCallTypeData.type == 'main'){
            this.mainCallTypes.push(data)
          }
          else if(this.newCallTypeData.type == 'other'){
            this.otherCallTypes.push(data)
          }
          this.closeNewCallType();
        })
      }
      else{
        this.newCallTypeData.feedback = "Vul alle velden in om op te slaan";
      }
    },

    

    getPopupData(){
      this.dataloaded = false;
      db.collection("callTypes")
        .where('companyType', '==', this.activeCompType)
        .where('deleted', '==', false)
        .orderBy('order')
        .get()
        .then(snap => {
          this.mainCallTypes = [];
          this.otherCallTypes = [];
          snap.forEach(doc => {
            let callType = doc.data();
            callType.docId = doc.id;
            if(callType.type == 'main'){
              this.mainCallTypes.push(callType)
            }
            else if(callType.type == 'other'){
              this.otherCallTypes.push(callType)
            }
          });
        })
        .then(() => {
          if (this.mainCallTypes.length > 0) {
            this.mainCallTypes.sort(this.sortCallTypes);
            this.orderMainCallTypes();
          }
          if (this.otherCallTypes.length > 0) {
            this.otherCallTypes.sort(this.sortCallTypes);
            this.orderOtherCallTypes();
          }
        })
        .then(()=>{
          this.dataloaded = true
        })
    },

    sortCallTypes(a, b) {
      // Use toUpperCase() to ignore character casing
      const genreA = a.order;
      const genreB = b.order;

      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    },

    orderMainCallTypes() {
      let element = document.querySelector(".main-table tbody");
      const vm = this;
      Sortable.create(element, {
        handle: ".grap",
        onEnd({ newIndex, oldIndex }) {
          const rowSelected = vm.mainCallTypes.splice(oldIndex, 1)[0]; // Get the selected row and remove it
          vm.mainCallTypes.splice(newIndex, 0, rowSelected); // Move it to the new index
          vm.updateOrderMainCallType();
        }
      });
    },

    orderOtherCallTypes() {
      let element = document.querySelector(".other-table tbody");
      const vm = this;
      Sortable.create(element, {
        handle: ".grap",
        onEnd({ newIndex, oldIndex }) {
          const rowSelected = vm.otherCallTypes.splice(oldIndex, 1)[0]; // Get the selected row and remove it
          vm.otherCallTypes.splice(newIndex, 0, rowSelected); // Move it to the new index
          vm.updateOrderOtherCallType();
        }
      });
    },

    updateOrderMainCallType() {
      let callTypes = this.mainCallTypes;
      callTypes.forEach(item => {
        let numberItem = callTypes.indexOf(item);
        // console.log("Update Question Order: " + item.order + " wordt ArrayIndex: " + numberItem);
        db.collection("callTypes")
          .doc(item.docId)
          .update({
            order: numberItem
          });
      });
    },

    updateOrderOtherCallType() {
      let callTypes = this.otherCallTypes;
      callTypes.forEach(item => {
        let numberItem = callTypes.indexOf(item);
        // console.log("Update Question Order: " + item.order + " wordt ArrayIndex: " + numberItem);
        db.collection("callTypes")
          .doc(item.docId)
          .update({
            order: numberItem
          });
      });
    }
  },

  computed: {
    editCallTypeChanged(){
      if(_.isEqual(this.editCallTypeData, this.editCallTypeDataOriginal)){
        return false
      } else {
        return true
      }
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>
